'use client';

import React, { useEffect, useState } from 'react';
import { useRouter, usePathname } from 'next/navigation';
import Sidebar from '@/components/layout/Sidebar';
import Header from '@/components/layout/Header';
import { authService } from '@/lib/api/auth.service';

export default function DashboardLayout({ children }: { children: React.ReactNode }) {
  const router = useRouter();
  const pathname = usePathname();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    let active = true;
    authService
      .getMe()
      .then((response) => {
        if (!active) return;
        if (!response.success || response.data?.role !== 'admin') {
          throw new Error('Admin session required');
        }
        setChecked(true);
      })
      .catch(() => {
        if (!active) return;
        const current = window.location.pathname + window.location.search;
        router.replace(`/login?redirect=${encodeURIComponent(current)}`);
      });
    return () => {
      active = false;
    };
  }, [router]);

  useEffect(() => {
    setSidebarOpen(false);
  }, [pathname]);

  if (!checked) return null;

  return (
    <div className="flex h-screen bg-gray-50 dark:bg-gray-950">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="flex-1 flex flex-col overflow-hidden lg:ml-0">
        <Header onMenuClick={() => setSidebarOpen(!sidebarOpen)} />
        <main className={`flex-1 overflow-auto${/^\/blog\/.+/.test(pathname) ? '' : ' p-4 lg:p-6'}`}>
          {children}
        </main>
      </div>
    </div>
  );
}
